<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

const { accountScopedRoute } = useAccount();
const notificationMetadata = useMapGetter('notifications/getMeta');
const route = useRoute();
const notificationsRoute = computed(() => accountScopedRoute('notifications_index'));
const isActive = computed(() => route.name === 'notifications_index');
const showNotificationBell = false;

const unreadCount = computed(() => {
  if (!notificationMetadata.value.unreadCount) {
    return '';
  }

  return notificationMetadata.value.unreadCount < 100
    ? `${notificationMetadata.value.unreadCount}`
    : '99+';
});
</script>

<template>
  <RouterLink
    v-if="showNotificationBell"
    :to="notificationsRoute"
    class="size-8 rounded-lg flex-shrink-0 grid place-content-center relative transition-colors"
    :class="[
      isActive
        ? 'bg-n-alpha-2 text-n-brand'
        : 'hover:bg-n-alpha-1 text-n-slate-11',
    ]"
  >
    <span class="i-lucide-bell size-4" />
    <span
      v-if="unreadCount"
      class="min-h-2 min-w-2 p-0.5 px-1 bg-n-ruby-9 rounded-lg absolute -top-1 -right-1.5 grid place-items-center text-[9px] leading-none text-n-ruby-3"
    >
      {{ unreadCount }}
    </span>
  </RouterLink>
</template>
